import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business } from '../../data/site';
import { heroBanner } from '../../data/gallery';
import { ui } from '../../data/ui';
import { buttonClass } from '../../utils/styles';
import { TrustBadges } from '../TrustBadges';
import { StarRating } from '../StarRating';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative isolate overflow-hidden bg-navy-deep" data-id="element-144" data-mp="5onpcitzgxbn">
      <img src={heroBanner} alt={t({
      en: 'Remodeled open-concept kitchen with navy cabinets, quartz island and new wood-look flooring, with M&S Multiservices premium paint and brushes in the foreground',
      es: 'Cocina remodelada de concepto abierto con gabinetes azul marino, isla de cuarzo y piso nuevo tipo madera, con pintura y brochas premium de M&S Multiservices al frente'
    })} className="absolute inset-0 -z-20 h-full w-full object-cover object-center" data-id="element-145" data-mp="pkmn51h736u" />
      <div className="absolute inset-0 -z-10 bg-navy-deep/55 sm:bg-navy-deep/45" aria-hidden="true" data-id="element-146" data-mp="1rw72mewzy8lb" />
      <div className="absolute inset-0 -z-10 bg-[linear-gradient(to_right,rgba(0,31,63,0.35)_0%,rgba(0,31,63,0.25)_45%,rgba(0,31,63,0.25)_100%)]" aria-hidden="true" data-id="element-147" data-mp="1czzifell9761" />

      <div className="mx-auto max-w-7xl px-6 pb-16 pt-16 sm:pb-24 sm:pt-24 lg:pb-32 lg:pt-32" data-id="element-148" data-mp="25nc65s3hjl0x">
        <motion.div className="max-w-2xl" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-149" data-mp="2aldqegcndqdz">
          <p className="font-display text-lg italic text-gold" data-id="element-150" data-mp="20ualf3glkr9f">
            {t({
            en: 'Dallas–Fort Worth · Family owned since 2015',
            es: 'Dallas–Fort Worth · Negocio familiar desde 2015'
          })}
          </p>
          <h1 className="mt-4 font-display text-4xl leading-[1.08] text-white [text-shadow:0_2px_12px_rgba(0,20,40,0.45)] sm:text-5xl xl:text-6xl" data-id="element-151" data-mp="338wvkt2kbqfc">
            {t({
            en: 'Professional Home Remodeling & Renovation Services in Dallas',
            es: 'Servicios Profesionales de Remodelación en Dallas'
          })}
          </h1>
          <p className="mt-6 max-w-xl text-lg text-white/90 sm:text-xl" data-id="element-152" data-mp="2p8cf43k4e6p0">
            {t({
            en: 'Painting • Drywall • Flooring • Handyman Services • And More',
            es: 'Pintura • Drywall • Pisos • Reparaciones • Y Mucho Más'
          })}
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-153" data-mp="2akj0al2uz87h">
            <Link to="/contact" className={buttonClass('gold', 'lg')} data-id="element-154" data-mp="26inx1b1dakr2">
              {t(ui.freeEstimateToday)}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="21jb1m1wfk5cv" />
            </Link>
            <a href={business.phoneHref} className={buttonClass('white', 'lg')} data-id="element-156" data-mp="1wjeye4vk4hyd">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="c261lcwj30tp" />
              {business.phoneDisplay}
            </a>
          </div>

          <div className="mt-10 border-t border-white/20 pt-7" data-id="element-158" data-mp="gzxuoa8wsszh">
            <TrustBadges tone="dark" data-id="element-159" data-mp="m0d4irtzficp" />
          </div>
        </motion.div>

        <motion.div className="mt-10 w-full max-w-xs rounded-lg bg-white p-5 shadow-lift lg:mt-16" initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-160" data-mp="lxzdqv6c4say">
          <StarRating label={t({
          en: '5 out of 5 stars',
          es: '5 de 5 estrellas'
        })} data-id="element-161" data-mp="3ug5758rkhny7" />
          <p className="mt-3 font-display text-2xl text-navy" data-id="element-162" data-mp="2bb57fpkikuj">
            {t({
            en: '500+ projects',
            es: '500+ proyectos'
          })}
          </p>
          <p className="mt-1 text-sm text-ink/70" data-id="element-163" data-mp="74nn76zqrteb">
            {t({
            en: 'completed across the Metroplex, residential and commercial.',
            es: 'completados en el Metroplex, residencial y comercial.'
          })}
          </p>
        </motion.div>
      </div>
    </section>;
}